import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSimaTechContext } from './Context';

function NavMenu() {
  const { state } = useSimaTechContext();

  return (
    <Row>
      <Col xs={12} className="d-sm-none">
        <h2 className="mt-3">{state.vehicleName}</h2>
        <img className="mt-3" src="images/falck-logo.gif" alt="headerlogo" />
        <h2 className="mt-3">Uge-/dagsplan</h2>
      </Col>
      <Col sm={4} className="d-none d-sm-block">
        <img className="mt-3" src="images/falck-logo.gif" alt="headerlogo" />
      </Col>
      <Col sm={4} className="d-none d-sm-block">
        <h2 className="mt-3 text-center">{state.vehicleName}</h2>
      </Col>
      <Col sm={4} className="d-none d-sm-block">
        <h2 className="mt-3 float-end">Uge-/dagsplan</h2>
      </Col>
    </Row>
  );
}

export default NavMenu;
